/**
 * 文字转图片
 * @param text
 * @returns {string}
 */
export const textConvertImg = (text) => {
  //基本字体大小
  let baseFont = "italic bold 14px sans-serif";
  let canvas = document.createElement('canvas');
  let context = canvas.getContext("2d");
  //设置字体并计算该字体占用宽度并+10
  context.font = baseFont;
  canvas.width = context.measureText(text).width + 10;
  //设置画布高度
  canvas.height = 22;
  //设置背景颜色
  context.fillStyle = "#d5e8e5";
  //绘制背景
  context.fillRect(0, 0, canvas.width, canvas.height);
  //设置文字颜色
  context.fillStyle = "#484848";
  //设置文字字体
  context.font = baseFont;
  //设置居中
  context.textAlign = "center";
  context.textBaseline = "middle";
  //绘制文字
  context.fillText(text, canvas.width / 2, canvas.height / 2);
  return canvas.toDataURL("image/png", 1)
};



// WEBPACK FOOTER //
// ./src/js/utils/imgUtils.js